// extracted by mini-css-extract-plugin
module.exports = {"includedBaggage__root":"includedBaggage__root-1UPoX","includedBaggage__header":"includedBaggage__header-2M1ey","includedBaggage__footer":"includedBaggage__footer-1Swxe"};